import React from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import App from './App'
import LegalPage from './pages/LegalPage'
import DataProtectionPage from './pages/DataProtectionPage'
import NotFound from './pages/NotFound'

const Router = () => (
    <BrowserRouter>
        <Switch>
            <Route path="/campaign/:cid/:filter?" component={App} />
            <Route path="/impressum" component={LegalPage} />
            <Route path="/data-protection" component={DataProtectionPage} />
            <Route component={NotFound} />
        </Switch>
    </BrowserRouter>
)

export default Router



// WEBPACK FOOTER //
// ./src/components/Router.js